<mat-form-field appearance="outline"
  [ngStyle]="{'color': ngControl.control.errors?.required ? 'red' : 'inherit'}" style="width: 100%; height: 100%"
  [matBadge]="badge"
  >
  <mat-label>{{ placeholder }}</mat-label>
  <input #inputField
    matInput
    [placeholder]="placeholder"
    (keyup)="updateValue($event)"
    [disabled]="disabled"
    [errorStateMatcher]="matcher">
    <!-- <mat-error *ngIf="ngControl.control.errors?.required">error required***</mat-error> -->
    @if (ngControl.control.errors?.required) {
      <mat-hint
        style="color: #f73356;">{{'form.validation.required' | translate}}
      </mat-hint>
    }
    <!-- <div *ngIf="ngControl.control.invalid">invalid!!!</div>
    <div *ngIf="ngControl.control.errors?.required">Required!!!</div> -->
  </mat-form-field>
